<div class="background" [class.visible]="visible">
  <i (click)="close()" class="bi bi-x"></i>
  <img [src]="data.src" alt="detail" />
</div>
